import script from "./EstimatesJobsRatingCardsLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./EstimatesJobsRatingCardsLayout.vue?vue&type=script&lang=ts&setup=true"

import "./EstimatesJobsRatingCardsLayout.vue?vue&type=style&index=0&id=883bde5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-883bde5c"]])

export default __exports__